import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { MaskLineScroll } from "../components/Reveal";
import { BRAND } from "../lib/brand";

export default function Portal() {
  return (
    <>
      <SEO
        title="Customer Portal — ProForm Paint & Body"
        description="The ProForm customer portal is coming. Track inquiry status, view uploaded photos, and confirm contact info once available."
        canonical={`https://${BRAND.domain}/portal`}
      />
      <section className="pt-32 md:pt-40 pb-24">
        <div className="wrap max-w-3xl">
          <div className="label mb-3">— Portal · 001</div>
          <h1 className="font-display uppercase text-5xl md:text-8xl leading-[0.88] tracking-tight">
            <MaskLineScroll>Customer</MaskLineScroll>
            <MaskLineScroll delay={0.08}><span className="text-proform-red">portal</span>.</MaskLineScroll>
          </h1>
          <p className="mt-8 text-chrome-300 text-lg leading-relaxed">
            A secure portal is being built to let customers track inquiry status, review approved documents, upload additional photos, and confirm contact info. It launches once the initial claim and project pipeline is stable.
          </p>

          <div className="mt-12 card p-8">
            <div className="label mb-3">In the meantime</div>
            <p className="text-chrome-100">
              Use your inquiry reference number (from the estimate confirmation email) to reference your project when you contact Cody. For any updates, questions, or additions:
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/estimate" className="btn btn-primary">Start a new inquiry</Link>
              <a href={`tel:${BRAND.phoneRaw}`} className="btn">Call {BRAND.phoneDisplay}</a>
              <a href={`sms:${BRAND.phoneRaw}`} className="btn">Text ProForm</a>
              <a href={`mailto:${BRAND.email}`} className="btn">Email Cody</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
